import { BaseRouteService } from "core/services";

class WoundOrderRouteService extends BaseRouteService {
    constructor() {
        super("woundOrders");
    }

    find(filter) {
        return super.find(
            this.base +
                "/{?patientId,facilityId,woundOrderStatusId,assessmentDate,dateOfService,searchQuery,page,rpp,sort,embed,fields}",
            filter
        );
    }

    get(id, options) {
        return super.get(this.base + "/{id}/{?embed,fields}", id, options);
    }

    update(resource) {
        return super.update(this.base + "/{id}", resource);
    }

    delete(resource) {
        return super.delete(this.base + "/{id}", resource);
    }

    create(resource) {
        return super.create(this.base, resource);
    }
}

export default WoundOrderRouteService;
